import { render } from "./LocationComponentUI.vue?vue&type=template&id=a9a3ecae"
import script from "../js/location-component-ui.js?vue&type=script&lang=js"
export * from "../js/location-component-ui.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__